var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",null,{"scope":_vm.sharedScope}),_vm._v(" "),(_vm.liteboxVisible)?_c('portal',{attrs:{"to":"modals"}},[_c('vue-litebox',{attrs:{"items":_vm.liteboxItems,"start-at":_vm.liteboxStartAt},on:{"close":_vm.hideLitebox}})],1):_vm._e()],2)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d31a0f9c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/MapBlock.vue
// module id = 75
// module chunks = 2